"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M22.196 11.99C21.957.72 6.972-3.482 1.199 7.08c.258.19.606.438.864.617a10.752 10.752 0 00-.894 2.812c-.11.616-.169 1.252-.169 1.898C1 18.25 5.75 23 11.603 23a10.59 10.59 0 0010.593-10.593v-.417zM3.613 13.878c-.139 1.143-.05 1.5-.05 1.64l-.258.089c-.099-.189-.337-.855-.447-1.75C2.58 10.45 4.905 7.38 8.453 6.804c3.25-.477 6.36 1.54 7.085 4.362l-.258.09c-.08-.08-.209-.309-.706-.806-3.925-3.925-10.086-2.126-10.96 3.429zM13.7 15.786a2.882 2.882 0 01-2.375 1.242 2.888 2.888 0 01-2.892-2.892 2.895 2.895 0 012.683-2.882c.934-.04 1.809.467 2.216 1.282a2.364 2.364 0 01-.417 2.703c.268.189.526.368.785.547zm6.032.109c-1.53 3.468-4.68 5.287-8.04 5.237-6.449-.318-8.327-7.761-4.014-10.444l.189.189c-.07.1-.328.298-.726 1.083-.467.954-.616 1.908-.556 2.504.338 5.197 7.621 6.26 10.126 1.113 3.19-7.045-5.277-14.21-12.79-8.735l-.168-.169c1.977-3.1 5.843-4.481 9.53-3.557 5.634 1.42 8.664 7.294 6.449 12.779z" }), "Uplay");
//# sourceMappingURL=Uplay.js.map